import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { MessageService } from 'primeng/api'
import { Observable, map } from 'rxjs'

import { ApiOmnichannelTimelineService } from '../../data/services/api/api-omnichannel-timeline.service'
import { ChannelSourcesViewService } from '../../data/services/view/channel-sources-view.service'

@Component({
  selector: 'app-assign-channel-modal',
  templateUrl: './assign-channel-modal.component.html',
  styleUrls: ['./assign-channel-modal.component.scss'],
  providers: [MessageService],
})
export class AssignChannelModalComponent implements OnInit {
  @Input() clientId!: string
  @Input() currentChannelKey: string | null = null
  @Input() visible = false

  @Output() visibleChange = new EventEmitter<boolean>()
  @Output() assigned = new EventEmitter<void>()

  form: FormGroup
  options$: Observable<{ label: string; value: string }[]>

  constructor(private fb: FormBuilder, private api: ApiOmnichannelTimelineService, private channels: ChannelSourcesViewService, private messageService: MessageService) {
    this.form = this.fb.group({
      channelKey: [null, Validators.required],
      reason: [''],
    })
    this.options$ = this.channels.sources$.pipe(map((list) => list.filter((s) => s.active && s.key !== this.currentChannelKey).map((s) => ({ label: s.label, value: s.key }))))
  }

  ngOnInit(): void {
    this.channels.loadAll(1, 100)
  }

  submit(): void {
    if (this.form.invalid) return
    const { channelKey, reason } = this.form.value
    this.api.assignChannel(this.clientId, { channelKey, reason }).subscribe((r) => {
      if (!r.error) {
        this.messageService.add({ severity: 'success', summary: 'Canal asignado', detail: r.msg, life: 3000 })
        this.assigned.emit()
        this.close()
      } else {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: r.msg, life: 4000 })
      }
    })
  }

  close(): void {
    this.visible = false
    this.visibleChange.emit(false)
  }
}
